<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PlayerIconButton from '@/components/quran/player/PlayerIconButton.vue';
import UiPopover from '@/components/ui/UiPopover.vue';
import { useQuranPlayer } from '@/composables/quran/useQuranPlayer';

/** Stop the recitation after a while — for listening before sleep. */
defineProps({
  placement: { type: String, default: 'top' },
});

const { t } = useI18n();
const player = useQuranPlayer();

const options = computed(() => [
  { value: 15, label: t('quran.player.sleepMinutes', { n: 15 }) },
  { value: 30, label: t('quran.player.sleepMinutes', { n: 30 }) },
  { value: 60, label: t('quran.player.sleepMinutes', { n: 60 }) },
  { value: 'end', label: t('quran.player.sleepEnd') },
]);

const badge = computed(() => {
  if (player.sleepMinutesLeft.value != null) return `${player.sleepMinutesLeft.value}m`;
  return player.state.sleep?.atEnd ? '⏹' : null;
});
</script>

<template>
  <UiPopover :placement="placement" align="center" tone="dark" :label="t('quran.player.sleep')">
    <template #trigger="{ toggle }">
      <PlayerIconButton icon="solar:moon-sleep-linear" size="sm" :label="t('quran.player.sleep')" :active="Boolean(player.state.sleep)" :badge="badge" @click="toggle" />
    </template>
    <template #default="{ close }">
      <p class="px-3 pt-1 pb-2 text-[10px] font-bold uppercase tracking-widest text-white/40">{{ t('quran.player.sleep') }}</p>
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="w-full text-left px-3 py-2 rounded-xl text-sm font-semibold text-white/80 hover:bg-white/10"
        @click="player.setSleep(option.value); close()"
      >{{ option.label }}</button>
      <button
        v-if="player.state.sleep"
        type="button"
        class="w-full text-left px-3 py-2 rounded-xl text-sm font-semibold text-deen-gold hover:bg-white/10"
        @click="player.setSleep(null); close()"
      >{{ t('quran.player.sleepOff') }}</button>
    </template>
  </UiPopover>
</template>
